// extracted by mini-css-extract-plugin
module.exports = {"productName__brand":"Name_productName__brand__DXdCz"};